import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { SectionWithTitle } from "../sectionWithTitle";
const Details = ({ sectionName, configPath, location, sectionProps, }) => {
    const { translate } = useI18n();
    const rows = [
        location.formatted_address && { key: "address", value: location.formatted_address },
        { key: "lat_lng", value: `${location.lat}, ${location.lng}` },
        location.what_3_words && { key: "what_3_words", value: location.what_3_words },
        location.email && { key: "email", value: location.email },
        location.website && { key: "website", value: location.website },
        location.other_website && { key: "other_website", value: location.other_website },
    ].filter(Boolean);
    return (_jsx(SectionWithTitle, { id: sectionName, sectionTokenPath: `${configPath}sections.${sectionName}`, className: `details details--${sectionName}`, ...sectionProps, children: _jsx("div", { role: "grid", children: rows.map(({ key, value }) => (_jsxs("div", { className: "details__row", role: "row", children: [_jsx("strong", { className: "details__key", id: `details-${key}`, role: "gridcell", children: translate(`${configPath}sections.${sectionName}.${key}`) }), _jsx(DetailsValue, { label: key, value: value })] }, key))) }) }));
};
const DetailsValue = ({ label, value }) => {
    if (!label)
        return null;
    if (label.includes("website")) {
        return (_jsx("a", { className: "details__value", "aria-labelledby": `details-${label}`, role: "gridcell", href: value, children: value }));
    }
    return (_jsx("div", { className: "details__value", "aria-labelledby": `details-${label}`, role: "gridcell", children: value }));
};
export { Details };
